import { TypeHeaderFields } from '@/core/generated-types/TypeHeader';

export enum NAV_TYPES {
  NORMAL = 'normal',
  SIMPLE = 'simple',
  STICKY = 'sticky',
}

export enum NAV_URLS {
  HOME = '/',
  SUBFLOW_CHILD_INFO = '/pages/subscription-v3/child-info',
  SUBFLOW_ORDER_REVIEW = '/pages/subscription-v3/order-review',
}

export const isSubflowPathname = (pathname: string | null) => {
  return (
    pathname === NAV_URLS.SUBFLOW_CHILD_INFO ||
    pathname === NAV_URLS.SUBFLOW_ORDER_REVIEW
  );
};

export const shouldShowGlobalBanner = ({
  enableGlobalBanner,
  globalBanner,
}: TypeHeaderFields) => {
  return enableGlobalBanner && globalBanner;
};
